import { SiteCellularDetails } from 'clipsal-cortex-types/src/api/api-site-cellular-details';

import { baseApi } from '../../../app/services/baseApi';
import { HardwareConnection } from './types';

export const hardwareApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCellularModemDetails: build.query<HardwareConnection, number>({
      query: (siteId) => `/v1/sites/${siteId}/site_devices/cellular_modem_details`,
      transformResponse: (data: SiteCellularDetails) => ({
        type: 'CELLULAR_MODEM',
        ...data.cellular_modem,
      }),
      providesTags: ['CellularModemDetails'],
    }),
  }),
});

export const { useGetCellularModemDetailsQuery } = hardwareApi;
